import moment from 'moment';
import { find } from 'lodash';

const _ = { find };

export function convHasUnreadMessages(conv) {
    // console.log('convHasUnreadMessages', 'created', conv.messages[0].created, 'is after lastread', conv.lastRead, !conv.messages[0].isOutbound && moment(conv.messages[0].created).isAfter(moment(conv.lastRead)));
    return (conv.messages[0] && !conv.messages[0].isOutbound && moment(conv.messages[0].created).isAfter(conv.lastRead));
}

export const getMemberEntityObject = (types, memberId, memberContextTypeId) => {
    return {
        entityId: memberId,
        entityType: 'member',
        entityContext: _.find(types.messagingMemberContextType, { id: memberContextTypeId }).value,
    };
};

export const MemberContextTypes = {
    EVENT_PARTCIPANT: 1,
    EVENT_ORGANIZER: 2,
    CLUB_ORGANIZER: 3,
    CLUB_MEMBER: 4,
    PLAYER: 5,
    COLLEGE_RECRUITER: 6,
    COLLEGE_RECRUIT: 7,
};

export const ConversationContextTypes = {
    EVENT_PROFILE: 1,
    CLUB_PROFILE: 2,
    PLAYER_PROFILE: 3,
    INBOX: 4,
    COLLEGE_RECRUIT_SEARCH: 5,
};
